var _defs, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwitzerland = function SvgSwitzerland(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Switzerland_svg__a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Switzerland_svg__b"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Switzerland_svg__i",
    cx: 99.9,
    cy: 100.3,
    r: 97.4,
    transform: "rotate(-45 99.86 100.336)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Switzerland_svg__c"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Switzerland_svg__i",
    cx: 319.5,
    cy: 99.7,
    r: 97.1
  })), /*#__PURE__*/React.createElement("style", null, ".Switzerland_svg__i,.Switzerland_svg__l{stroke-width:0}.Switzerland_svg__i{fill:none}.Switzerland_svg__l{fill:#fff}"))), /*#__PURE__*/React.createElement("circle", {
    cx: 99.9,
    cy: 100.3,
    r: 97.4,
    transform: "rotate(-45 99.86 100.336)",
    style: {
      stroke: "#a5a7aa",
      strokeMiterlimit: 10,
      strokeWidth: "1.8px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Switzerland_svg__b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ed2224",
      strokeWidth: 0
    },
    d: "M-46.3 2.9H246v194.9H-46.3z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Switzerland_svg__l",
    d: "M39.4 82h121v36.5h-121z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Switzerland_svg__l",
    d: "M81.7 39.4H118v121.8H81.7z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Switzerland_svg__i",
    cx: 99.9,
    cy: 100.3,
    r: 97.4,
    transform: "rotate(-45 99.86 100.336)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#Switzerland_svg__c)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Switzerland_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#669ad2",
      strokeWidth: 0
    },
    d: "M173.8 2.7h291.4V197H173.8z",
    id: "Switzerland_svg__e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Switzerland_svg__f",
    style: {
      strokeWidth: 0,
      fill: "#171715"
    },
    d: "M173.8 67.5h291.4V197H173.8z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Switzerland_svg__g",
    className: "Switzerland_svg__l",
    d: "M173.8 132.2h291.4V197H173.8z"
  }))));
};
export default SvgSwitzerland;